import { forwardRef } from 'react';

import * as S from './styled/Card.styled';

/**
 * @description Layout for the cards
 * @param {object} props
 * @param {string} [props.className]
 * @param {0 | 1 | 2 | 3 | 4 | 5} [props.padding= 2] - Padding size
 * @param {0 | 1 | 2 | 3 | 4 | 5} [props.margin= 0] - Margin size
 * @param {boolean} [props.border=true] - Border size
 * @param {boolean} [props.background=true] - Color of the card
 * @param {boolean} [props.rounded=true] - If true, card will be rounded
 * @param {boolean} [props.shadowed=false] - If true, card will be shadowed
 * @param {boolean} [props.fullWidth=false] - If true, card will be full width
 * @param {boolean} [props.fullHeight=false] - If true, card will be full height
 * @param {boolean} [props.style] - Style of the card
 * @example
 *<Card>
 *	<Typography>{t('noRecordsFoundTitle')}</Typography>
 *</Card>
 */
const Card = (
	{
		children,
		className,
		padding = 2,
		margin = 0,
		background = true,
		border = true,
		rounded = true,
		shadowed,
		fullWidth,
		fullHeight,
		...restProps
	},
	ref
) => (
	<S.Container
		ref={ref}
		className={`card ${className ?? ''} ${background ? 'background ' : ''}${rounded ? 'rounded ' : ''}${
			shadowed ? 'shadowed ' : ''
		}${fullWidth ? 'fullWidth ' : ''}${fullHeight ? 'fullHeight ' : ''}${border ? 'border ' : ''}`}
		padding={padding}
		margin={margin}
		{...restProps}>
		{children}
	</S.Container>
);

export default forwardRef(Card);
